import React from "react";
//import { StatusBar, View, Text } from "react-native";
import { Container, Header, Title, Left, Icon, Right, Button, Body, Content,Text, Card, CardItem, CardSwiper } from "native-base";
import { Styles } from '../../utils';

export default class DashboardSub extends React.Component {
   render() {
    return (
      <Container>
        <Content padder>
            <Card>
              <CardItem>
                <Text>Dash Sub</Text>
              </CardItem>
            </Card>
        </Content>
      </Container>
    );
  }
 }
